import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { createAEGTheme } from '@aeg-presents/components/AEGTheme';
import { AppRoutes } from './routes/AppRoutes';

const appTheme = createAEGTheme();

export function App() {
  return (
    <ThemeProvider theme={appTheme}>
      <CssBaseline />
      <AppRoutes />
    </ThemeProvider>
  );
}
